import { PropsWithChildren } from 'react';
import styles from './alert.module.css';

type AlertProps = PropsWithChildren<{
    severity?: 'error' | 'success' | 'info' | 'warning';
    className?: string;
    style?: React.CSSProperties;
}>;

export function Alert({ severity = 'info', className, style, children }: AlertProps) {
    const cls = `${styles.container} ${
        severity === 'error'
            ? styles.error
            : severity === 'success'
              ? styles.success
              : severity === 'warning'
                ? styles.warning
                : styles.info
    } ${className || ''}`;
    return (
        <div className={cls} style={style}>
            <div className={styles.content}>{children}</div>
        </div>
    );
}

export default Alert;
